import { render, staticRenderFns } from "./exhibitionBox.vue?vue&type=template&id=6230d5d4&scoped=true"
import script from "./exhibitionBox.vue?vue&type=script&lang=js"
export * from "./exhibitionBox.vue?vue&type=script&lang=js"
import style0 from "./exhibitionBox.vue?vue&type=style&index=0&id=6230d5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230d5d4",
  null
  
)

export default component.exports